<style lang="less">
.wx-tabbar {

	padding:0 0 12px;

	//覆盖element样式
	.el-tabs__nav-wrap::after{
		height:1px;
	}
	.el-tabs__content{
		display:none;
	}
	.el-tabs__item{
		font-size:16px;
	}
	.el-tabs__header{
		margin:0;
	}
}
</style>

<template>
<div class="wx-tabbar">
	<slot></slot>
</div>
</template>

<script>
export default {
    props: {
        part: {
			type: Boolean,
			default:false
        }
    }
};
</script>





// WEBPACK FOOTER //
// src/components/core/tabbar/Tabbar.vue